var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatusDisableDt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 6H12V7.5H5.5V10H6.75L4.75 12.5L2.75 10H4V6Z",
    fill: "#727E84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 12V8H17.25L15.25 5.5L13.25 8H14.5V10.5H8V12H16Z",
    fill: "#727E84"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 0.8C16.5 0.519974 16.5 0.379961 16.4455 0.273005C16.3976 0.178924 16.3211 0.102433 16.227 0.0544967C16.12 0 15.98 0 15.7 0H13.3C13.02 0 12.88 0 12.773 0.0544967C12.6789 0.102433 12.6024 0.178924 12.5545 0.273005C12.5 0.379961 12.5 0.519974 12.5 0.8V2H7.5V0.8C7.5 0.519974 7.5 0.379961 7.4455 0.273005C7.39757 0.178924 7.32108 0.102433 7.227 0.0544967C7.12004 0 6.98003 0 6.7 0H4.3C4.01997 0 3.87996 0 3.773 0.0544967C3.67892 0.102433 3.60243 0.178924 3.5545 0.273005C3.5 0.379961 3.5 0.519974 3.5 0.8V2H2C0.889999 2 0 2.89 0 4V14C0 15.11 0.889999 16 2 16H18C19.11 16 20 15.11 20 14L19.99 4C19.99 2.89 19.11 2 18 2H16.5V0.8ZM2 14V4L17.99 4.002L18 14H2Z",
    fill: "#727E84"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusDisableDt);
export default __webpack_public_path__ + "static/media/status_disable_dt.ed446a467c4c1ad0d33a1e323eb67c61.svg";
export { ForwardRef as ReactComponent };